import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Componente de redirect retrocompatível.
 * Captura /times/:timeId e redireciona para /colaboradores?time=:timeId (DT-04).
 */
@Component({
  selector: 'app-times-redirect',
  template: ''
})
export class TimesRedirectComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    const timeId = this.route.snapshot.paramMap.get('timeId');
    if (timeId) {
      this.router.navigate(['/colaboradores'], { queryParams: { time: timeId }, replaceUrl: true });
    } else {
      this.router.navigate(['/colaboradores'], { replaceUrl: true });
    }
  }
}
